var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[(_vm.user)?_c('div',{staticClass:"container"},[_c('UserUpdateFormComponent',{attrs:{"user":_vm.user,"cities":_vm.cities},on:{"update-user-requested":_vm.onUpdateUserRequested}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }